<template>
	<form action="" method="post" class="product_buying_form">

		<template v-if="this.working_variations.length >= 1 || ( use_icons==1)">
			<table width="100%" cellpadding="0" cellspacing="10" border="0" class="variation_table" :class="{ with_icons: use_icons=='1' }">
			<tr v-for="variation in this.working_variations" @click="selected_variation_id = variation.id" :class="{ selected: selected_variation_id == variation.id}">
				<td class="radio">
					<img :src="'/images/' + variation.snake_case + '.svg'" v-if="use_icons=='1'">
					<input type="radio" name="variation_id" :id="'variation_' + variation.id" v-model="selected_variation_id" :value="variation.id">
					<label :for="'variation_' + variation.id"></label>
				</td>
				<td>
					<b>{{ variation.name }}</b>
					<template v-if="variation.description != '' && variation.description != null"><br>{{ variation.description }}</template>
					<small v-if="variation.coverage > 0 && variation.product['use_per_meter_pricing']==0">Coverage: {{ variation.coverage }}m<sup>2</sup>
						<br><small v-if="variation.product.calculator_type=='combo_volume' || variation.product.calculator_type=='single_volume'">based on a depth of {{ aggregate_depth }}cm</small>
					</small>
					<template v-if="variation.is_sample == 1">
						<small>Samples are FREE OF CHARGE except for the cost of packaging and postage.
							<template v-if="product.supplier.allow_sample_discount">
							Customers will have their delivery charge refunded against their full order at the point of purchase.
							</template>
						</small>
					</template>
				</td>
				<td class="price">

					<template v-if="variation.product['use_per_meter_pricing']==1 && variation.is_sample == false">
						from
						<b>{{ format_currency(addVat(variation.pricing['selling_from_price'])) }}<sup>*</sup></b>
						per m<sup><small>2</small></sup>
						<span style="font-size: 0.8em; display: block; padding-top: 0.5em;">when you buy {{ variation.coverage }}m<sup>2</sup>&nbsp; or more</span>
					</template>
					<template v-else>
						<b>{{ format_currency(addVat(variation.pricing['selling_price'])) }}<sup>*</sup></b>
						<template v-if="product.show_equivalent_price && variation.pricing['variation_equivalent_m2'] > 0">
							<span class="equivalent">{{ format_currency(addVat(variation.pricing['variation_equivalent_m2'])) }}<sup>*</sup> per m<sup><small>2</small></sup></span>
						</template>
					</template>

						<div class="was" v-if="variation.product['use_per_meter_pricing']==1 && variation.pricing['selling_from_price'] < variation.pricing['selling_regular_price']">
							was <strike>{{ format_currency(addVat(variation.pricing['selling_regular_price'])) }}</strike>
						</div>

						<div class="was" v-if="variation.product['use_per_meter_pricing']==0 && variation.pricing['selling_price'] < variation.pricing['regular_price']">
							was <strike>{{ format_currency(addVat(variation.pricing['regular_price'])) }}</strike>
						</div>

					<template v-if="variation.in_basket > 0">
						<small class="in_basket">{{ variation.in_basket }}
						<template v-if="variation.product['use_per_meter_pricing']==1 && variation.is_sample == false">
						m<sup><small>2</small></sup>
						</template>
						in basket</small>
					</template>

				</td>
			</tr>
			</table>
		</template>

		<p class="price_and_quantity">
			<span class="calculated_price">
				{{ format_currency(calculated_price) }}<sup>*</sup>
			</span>

			<span class="quantity_control" v-if="product.buyable">
				<button type="button" v-on:click="adjustQty(selected_variation.tile_area > 0 ? 0 - selected_variation.tile_area : -1)" class="decrease"><i class="fal fa-fw fa-minus"></i></button>
				<input type="number" :min="product.use_per_meter_pricing ? (selected_variation.tile_area > 0 ? selected_variation.tile_area : '0.01') : '1'" max="1000" :step="product.use_per_meter_pricing ? (selected_variation.tile_area > 0 ? selected_variation.tile_area : '0.01') : '1'" name="quantity" class="quantity" v-model="quantity" v-on:keydown.enter.prevent >
				<span class="meter" v-if="this.selected_variation.product['use_per_meter_pricing']">m<sup><small>2</small></sup></span>
				<button type="button" v-on:click="adjustQty(selected_variation.tile_area > 0 ? selected_variation.tile_area : 1)" class="increase"><i class="fal fa-fw fa-plus"></i></button>
			</span>
		</p>

		<p class="pp_price_includes">
			* price includes VAT.
		</p>

		<p v-if="tiles_required > 0" class="pp_tile_message">
			<template v-if="tiles_required == Math.floor(tiles_required)">
				<i class="fas fa-check-circle"></i><span>This will give you {{ Math.floor(tiles_required) + " tile" + (Math.floor(tiles_required) == 1 ? '' : 's') }}, covering {{ area_coverage }}m<sup>2</sup> exactly</span>
			</template>
			<template v-else>
				<i class="fas fa-exclamation-triangle"></i><span>This will give you {{ Math.floor(tiles_required) + " tile" + (Math.floor(tiles_required) == 1 ? '' : 's') }}, covering {{ area_coverage }}m<sup>2</sup>. <button type="button" v-on:click="quantity = coverage_required" class="button solid upper primary">Update to {{ coverage_required }}m<sup>2</sup></button>
				</span>
			</template>
		</p>

		<div class="pp_add_to_basket" v-if="product.buyable">
			<input type="hidden" name="variation_id" :value="selected_variation.id">
			<button :disabled="submittable == 0" type="submit" class="button wide solid upper" v-on:click.prevent="addMulitpleToBasket()"><i class="fal fa-fw fa-shopping-basket"></i> Add To Basket</button>
        </div>

		<p v-if="1==2 && this.selected_variation_weight >= this.large_item_min_weight" class="pp_qty_alert warning">
			<i class="fas fa-exclamation-triangle fa-3x"></i>
			<span v-html="this.large_item_content"></span>
		</p>

		<p v-if="1==2 && this.selected_variation_weight < this.large_item_min_weight" class="pp_qty_alert warning">
			<i class="fas fa-check-circle fa-3x"></i>
			<span v-html="this.small_item_content"></span>
		</p>

		<p v-if="!product.show_loose_load_box && show_qty_alert" class="pp_qty_alert warning">
			<i class="fal fa-exclamation-circle fa-3x"></i>
			<span v-html="this.qty_alert_content"></span>
		</p>

		<p class="pp_qty_alert" v-if="this.services.length > 0">
			<i class="fal fa-truck"></i>
			<span>
				<template v-for="(service, index) in this.services">
					<template v-if="services.length > 1 && index > 0">, </template>
					<template v-if="services.length > 1 && services.length-1 == index">and </template>
					<b>{{ service['name'] }}</b>
				</template>
				delivery
				<template v-if="services.length == 1"> service </template>
				<template v-else> services </template>
				available<template v-if="this.services[0].allow_nominated_day == 1">, with choice of delivery day.</template>
			</span>
		</p>

		<p v-if="product.show_loose_load_box" class="pp_qty_alert neutral">
			<i class="fal fa-truck-container fa-3x"></i>
			<span v-html="this.loose_load_content"></span>
		</p>



		<template v-if="1==2 && Object.keys(this.working_also_needs).length > 0">
			<h2>You might also need</h2>
			<table cellpadding="0" cellspacing="0" border="0" class="also_buy also_need">
				<tr v-for="(variation, key) in working_also_needs">
					<td><img :src="variation.product.thumbnail_image" width="80" height="80" :alt="variation.full_name"></td>
					<td>
						<a :href="variation.product.full_slug" target="_blank">{{ variation.full_name }}</a> x&nbsp;{{ variation.qty }}
						<template v-if="variation.product.calculator_type=='grout'">
							<br><small>Suggested quantity based on a tile spacing of 5mm</small>
						</template>
						<template v-if="variation.product.calculator_type=='primer'">
							<br><small>Suggested quantity based on a coverage of {{ variation.coverage }}m<sup>2</sup></small>
						</template>
						<template v-if="variation.product.calculator_type=='membrane'">
							<br><small>Suggested quantity based on a coverage of {{ variation.coverage }}m<sup>2</sup> per roll</small>
						</template>
					</td>
					<td>
						<template v-if="variation.product['use_per_meter_pricing']==1 && variation.is_sample == 0">
							from
							<b>{{ getDisplayPrice(variation, 1) }}<sup>*</sup></b>
							per m<sup><small>2</small></sup>
							<span style="font-size: 0.8em; display: block;">when you buy {{ variation.coverage }}m<sup>2</sup>&nbsp; or more</span>
						</template>
						<template v-else>
							<b>{{ getDisplayPrice(variation, variation.qty) }}<sup>*</sup></b>
							<template v-if="variation.product.show_equivalent_price && variation.pricing['variation_equivalent_m2'] > 0">
								<span class="equivalent">{{ format_currency(addVat(variation.pricing['variation_equivalent_m2'])) }}<sup>*</sup> per m<sup><small>2</small></sup></span>
							</template>
						</template>
					</td>
					<td>
						<input type="checkbox" name="selected_also_needs" :value="true" v-model="variation.selected" :id="'also_need'+key">
						<label :for="'also_need'+key">Include</label>
					</td>
				</tr>
			</table>
		</template>

	</form>
</template>
<script>
import debounce from '../debounce.js';
import { mapGetters, mapActions } from 'vuex';

export default {

	directives: {debounce},

	props: [
		'product',
		'variations',
		'use_icons',
		'preselected_variation',
		'large_item_content',
		'small_item_content',
		'qty_alert_content',
		'loose_load_content',
		'large_item_min_weight',
		'also_needs'
	],

	data: () => {
		return {
			selected_variation_id: 0,
			quantity: 1,
			working_variations: {},
			working_product: {},
			show_qty_alert: false,
			tile_message: '',
			tiles_required: 0,
			area_coverage: 0,
			coverage_required: 0,
			services: {},
			working_also_needs: {},
			selected_also_needs: []
		}
	},

	computed: {
		...mapGetters({
			refreshStatus: 'getBuyingOptionsRefreshStatus'
		}),
		submittable: function(){
			if (this.tiles_required == Math.floor(this.tiles_required)) {
				return true;
			}
			return false;
		},
		aggregate_depth: function(){
			return process.env.MIX_DEPTH
		},
		calculated_price: function () {

			if (this.selected_variation.product['use_per_meter_pricing'] == 1 && this.selected_variation.is_sample==false) {
				if ((+this.quantity) < this.selected_variation.coverage) {
					return (
							this.addVat(this.selected_variation.pricing['product_portion'])
						 	* (+this.quantity)
						) + this.addVat(this.selected_variation.pricing['delivery_portion']);
				}else{
					return this.addVat(this.selected_variation.pricing['selling_from_price']) * (+this.quantity);
				}
			}else{
				return this.addVat(this.selected_variation.pricing['selling_price']) * (+this.quantity);
			}
		},
		selected_variation: function () {
			var result = this.working_variations.filter(obj => {
				return obj.id === this.selected_variation_id
			})
			result[0]['qty'] = this.quantity;
			return result[0];
		},
		selected_variation_weight: function() {
			if (this.selected_variation_id!=null) {
				if (this.selected_variation.product['use_per_meter_pricing'] == 1 && this.selected_variation.is_sample == false) {
					return (this.selected_variation.weight / this.selected_variation.coverage) * this.quantity ;
				}else{
					return this.selected_variation.weight;
				}
			}else{
				return 0;
			}
		}
	},

	watch: {
		refreshStatus: function(value) {
			if (value==true) {
				this.$store.commit('updateBuyingOptionsRefreshStatus', false);
				this.getProduct();
			}
		},
		selected_variation_id: function(value) {
			this.quantityCheck(true);
			this.checkStockAlert();
			this.getServices();
			this.updateAlsoQtys();
		},
		quantity: debounce(function(value) {
			value = parseFloat(Number(value).toFixed(2));
			// remove decimals if not required by the product
			if (!this.product.use_per_meter_pricing) {
				if(!Number.isInteger(+value) ) {
					this.quantity = Math.floor(+value).toFixed(0);
				}else{
					this.quantity = (+value).toFixed(0);
				}
			}

			this.quantityCheck();
			this.checkStockAlert();
			this.updateAlsoQtys();
		},500)
	},

	created() {
		this.selected_variation_id = this.variations[0].id;
		if (this.preselected_variation != null) {
			for (var i = 0, len = this.variations.length; i < len; i++) {

				if (this.variations[i]['sku'].trim() == this.preselected_variation.trim()) {
					this.selected_variation_id = this.variations[i].id;
					this.$nextTick(function () {
						if(this.product.use_per_meter_pricing && this.variations[i]['is_sample']==false) {
							this.quantity = this.selected_variation.coverage;
							this.quantityCheck();
						}
					});
					break;
				}
			}
		}
		this.working_product = this.product;
		this.working_variations = this.variations;
		this.working_also_needs = this.also_needs;
	},

	mounted() {
		this.quantityCheck();
		this.updateAlsoQtys();
	},

	methods: {
		// Map the Methods from the State Module
		...mapActions(['minicartRefresh']),

		adjustQty: function(qty) {
			var newQty = Number(this.quantity) + Number(qty);

			if (newQty < ( Number(this.selected_variation.tile_area) > 0 ? Number(this.selected_variation.tile_area) : 1 )) {
				newQty = (Number(this.selected_variation.tile_area) > 0 ? Number(this.selected_variation.tile_area) : 1 );
			};
			this.quantity = parseFloat(newQty.toFixed(2));

			//this.checkStockAlert();
		},

		checkStockAlert: function(){
			if (this.selected_variation.qty_alert_point != null && this.quantity >= this.selected_variation.qty_alert_point) {
				this.show_qty_alert = true;
			}else{
				this.show_qty_alert = false;
			}
		},

		addToBasket: function() {
			if( (this.quantity < 1 && this.product.use_per_meter_pricing == 0) || (this.quantity < 0 && this.product.use_per_meter_pricing == 1) ) {
				alert('You must set a quantity');
				return false;
			}
			axios.post('/box/basket/add', {
				Model_Type: '\\App\\Variation',
				Model_Id: this.selected_variation_id,
				Quantity: this.quantity,
				FreeTypeAttributes: ''
			}).then((response) => {
				this.$store.commit('updateMinicartRefreshStatus', true);
				for( var i = 0, len = this.working_variations.length; i < len; i++ ) {
					if( this.working_variations[i]['id'] === this.selected_variation_id ) {
						this.working_variations[i]['in_basket'] = this.working_variations[i]['in_basket'] + this.quantity;
						if(this.working_variations.length > 1) {
							this.added_popup(this.working_variations[i].name);
						}else{
							this.added_popup(this.product.name);
						}
						break;
					}
				}
			});
		},

		addMulitpleToBasket: function() {
			if( (this.quantity < 1 && this.product.use_per_meter_pricing == 0) || (this.quantity < 0 && this.product.use_per_meter_pricing == 1) ) {
				alert('You must set a quantity');
				return false;
			}

			var variations = [];
			variations.push(this.selected_variation);
			for( var i = 0, len = this.working_also_needs.length; i < len; i++ ) {
				if(this.working_also_needs[i].selected == true) {
					variations.push(this.working_also_needs[i]);
				}
			}


			axios.post('/ajax/addMultipleToBasket', {
				variations: variations
			}).then((response) => {
				this.$store.commit('updateMinicartRefreshStatus', true);
				var popup_text;
				for( var i = 0, len = this.working_variations.length; i < len; i++ ) {
					if( this.working_variations[i]['id'] === this.selected_variation_id ) {
						this.working_variations[i]['in_basket'] = this.working_variations[i]['in_basket'] + this.quantity;
						if(this.working_variations.length > 1) {
							popup_text = this.working_variations[i].name;
						}else{
							popup_text = this.product.name;
						}
						break;
					}
				}
				for( var i = 0, len = this.working_also_needs.length; i < len; i++ ) {
					if(this.working_also_needs[i]['selected'] == true) {
						popup_text += ', ' + this.working_also_needs[i].name;
					}
				}

				var pos = popup_text.lastIndexOf(',');
				if(pos > 0) {
					popup_text = popup_text.substring(0,pos) + ' and ' + popup_text.substring(pos+1)
				}
				this.added_popup(popup_text);
			});


		},

		getProduct: function() {
			axios.post('/ajax/getProduct', {
				product_id: this.product.id,
			}).then((response) => {
				this.working_product = response.data;
				this.working_variations = this.working_product.variations;
			});
		},

		added_popup: function(item) {

			$.alert({
				title: 'Great!',
				content: '<b>' + item + '</b> added to your basket.',
				buttons: {
					Continue: {
						text: 'Continue Shopping',
					},
					Basket: {
						text: 'View Basket',
						btnClass: 'btn-green',
						action: function () {
							window.location.href = '/basket'
						}
					}
				}
			});

		},

		popup: function(message) {
			$.alert({
				title: '',
				content: message,
				buttons: {
					Basket: {
						text: 'Continue',
						btnClass: 'btn-green',
					}
				}
			});

		},

		format_currency: function(value){
			return "£" + this.numberWithCommas((Math.round( (value + 0.0001) * 100 ) / 100).toFixed(2));
		},

		addVat: function(num) {
			var rate = process.env.MIX_VAT_RATE;
			var multiply_by = 1 + (rate / 100);
			// console.log(num);
			// console.log(multiply_by);
			// console.log(num * multiply_by);
			// console.log((num * multiply_by).toFixed(2));
			// console.log(parseFloat((num * multiply_by).toFixed(2)));
			return parseFloat((num * multiply_by).toFixed(2));
		},

		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		quantityCheck: function(autoset = true) {
			if(this.selected_variation.is_sample==false && this.selected_variation.product.use_per_meter_pricing == 1 && this.selected_variation.dimension_x > 0 && this.selected_variation.dimension_y > 0) {
				// first work out the coverage per tile
				var tile_coverage = (this.selected_variation.dimension_x / 1000) * (this.selected_variation.dimension_y / 1000);
				var tiles_required = parseFloat(this.quantity / tile_coverage).toFixed(2);
				this.tiles_required = tiles_required;
				this.area_coverage = parseFloat((Math.floor(tiles_required)*tile_coverage).toFixed(2));
				if(this.area_coverage < this.quantity) {
					this.coverage_required = parseFloat(((Math.floor(tiles_required)+1)*tile_coverage));
				}else{
					this.coverage_required = this.area_coverage;
				}
				if (autoset==true) { this.quantity = this.coverage_required; this.quantityCheck(false); }
			}else{
				// no dimensions on the variation, so lets allow it.
				this.area_coverage = 0;
				this.tiles_required = 0;
				this.coverage_required = 0;
			}
		},

		getServices: function() {
			axios.post('/ajax/getVariationShippingServices', {
				variation_id: this.selected_variation_id
			}).then((response) => {
				this.services = response.data;
			});
		},

		getDisplayPrice: function(variation, qty){
			if(variation.product['use_per_meter_pricing']==1 && variation.is_sample == 0){
				if (qty <= variation.coverage) {
					if(variation.product.discountable == 1 && this.product.discount_qualifier) {
						return this.format_currency(
							(this.addVat(variation.pricing['product_portion']) * qty)
						);
					}else{
						return this.format_currency(
							(this.addVat(variation.pricing['product_portion']) * qty)
							+
							(this.addVat(variation.pricing['delivery_portion']))
						);
					}
				}else{
					if(variation.product.discountable == 1 && this.product.discount_qualifier) {
						return this.format_currency(this.addVat(variation.pricing['product_portion']) * qty);
					}else{
						return this.format_currency(this.addVat(variation.pricing['selling_from_price']) * qty);
					}
				}
			}else{
				return this.format_currency(this.addVat(variation.pricing['selling_price']) * qty);
			}
		},

		updateAlsoQtys: function(){

			// loop through basket
			var total_grout_required = 0;
			var total_primer_required = 0;
			var total_membrane_required = 0;

			// calculate how much grout, primer and membrane is required
			if (this.product.use_per_meter_pricing == 1 && this.selected_variation.dimension_x > 0 && this.selected_variation.dimension_y > 0) {

				// grout calculation
				var grout_a = this.selected_variation.dimension_x + this.selected_variation.dimension_y;
				var grout_b = 5 * 20;
				var grout_c = grout_a * grout_b * 2;
				var grout_d = this.selected_variation.dimension_x * this.selected_variation.dimension_y;
				var grout_e = grout_c / grout_d;
				var grout_f = grout_e * this.quantity;
				total_grout_required += grout_f;

				// primer calculation
				total_primer_required += this.quantity;
			}
			if(this.product.calculator_type=='combo_volume') {
				var prod_coverage = this.selected_variation.coverage;
				total_membrane_required += (this.selected_variation.coverage * this.quantity);
			}


			for (var key in this.working_also_needs) {
				var variation = this.working_also_needs[key];
				if(variation.product.calculator_type=='grout') {
					var newqty = Math.ceil(total_grout_required / variation.weight);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
				if(variation.product.calculator_type=='primer') {
					var newqty = Math.ceil(total_primer_required / variation.coverage);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
				if(variation.product.calculator_type=='membrane') {
					var newqty = Math.ceil(total_membrane_required / variation.coverage);
					variation['qty'] = newqty > 0 ? newqty : 1;
				}
			}

		},

	}
};
</script>
